import { Interpolation, Theme } from '@emotion/react'
import { FC } from 'react'
import ReactDOM from 'react-dom'
import { usePlayerState } from '../../contexts/playerState'
import Markers from '../annotations/markers'
import Overlays from '../annotations/overlays'

interface Props {
  showSeekbar: boolean
  showMarkers: boolean
}

const Annotations: FC<Props> = ({
  showSeekbar,
  showMarkers,
}) => {
  const { isInitialized, playerInstance } = usePlayerState()

  if (!isInitialized || !playerInstance?.el()) return null

  return ReactDOM.createPortal(
    <div css={overlaysWrapperStyle}>
      <Overlays />
      {showSeekbar && showMarkers && <Markers />}
    </div>,
    playerInstance.el(),
  )
}

export default Annotations

const overlaysWrapperStyle: Interpolation<Theme> = () => ({
  width: '100%',
  height: '100%',
})
